import { Trans } from '@lingui/macro'
import { Button, Dialog, DialogContent, Grid, Typography } from '@mui/material'
import Form from 'app/views/forms/Form'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import { ReduxForms, ReduxState } from 'app/redux/ReduxInterfaces'
import { DialogTitleWithIconClose } from '../DialogTitleWithIconClose'
import './ProvideFeedbackButton.css'

export const FEEDBACK_FORM_ID = 'a3ZON00000022KH2AY'
export const RESOURCE_FEEDBACK_FORM_ID = 'a3ZON00000022If2AI'

interface ProvideFeedbackButtonProps {
  className?: string
  resourceId?: string
}

const ProvideFeedbackButton: React.FC<ProvideFeedbackButtonProps> = ({
  className,
  resourceId
}) => {
  const [open, setOpen] = useState(false)
  const reduxForms = useSelector<ReduxState, ReduxForms>(state => state.forms)

  const provideFeedbackForm = resourceId ? reduxForms.resourceFeedbackForm : reduxForms.provideFeedback

  const { enqueueSnackbar } = useSnackbar()

  const handleClose = (): void => {
    setOpen(false)
  }

  const feedbackButton = (
    <Button
      color='primary'
      variant='outlined'
      onClick={() => {
        setOpen(true)
      }}
    >
      <Typography className={`button-text ${className ?? ''}`}>
        <Trans>PROVIDE_FEEDBACK_BUTTON</Trans>
      </Typography>
    </Button>
  )

  // Early return if no form data
  if (!provideFeedbackForm || Object.keys(provideFeedbackForm).length === 0) {
    return feedbackButton
  }

  return (
    <>
      <Button
        color='primary'
        onClick={() => {
          setOpen(true)
        }}
        variant='outlined'
      >
        <Typography className={`button-text ${className ?? ''}`}>
          <Trans>PROVIDE_FEEDBACK_BUTTON</Trans>
        </Typography>
      </Button>
      {open && (
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth='xs'
          className='provide-feedback-dialog'
        >
          <DialogTitleWithIconClose handleClose={handleClose} />
          <DialogContent
            sx={{ paddingLeft: '48px', paddingRight: '48px', paddingBottom: '48px' }}
          >
            <Form
              mainObject='Case'
              defaultFormType='editable'
              formId={FEEDBACK_FORM_ID}
              renderData={provideFeedbackForm}
              style={{ padding: 0 }}
              containerViewType='clean'
              formTitlePrimaryColor
              centerFormTitle
              saveConnectedMap={Object.fromEntries(
                provideFeedbackForm.objectsConnected.map((obj) => {
                  return [
                    obj.identId,
                    {
                      sfObject: {
                        attributes: {
                          type: obj.type
                        }
                      }
                    }
                  ]
                })
              )}
              baseToSave={
                Object.fromEntries(
                  provideFeedbackForm.objectsConnected.map((obj) => {
                    return [
                      obj.identId,
                      {
                        Associated_Resource__c: resourceId,
                        Type: 'Resource Inventory'
                      }
                    ]
                  })
                )
              }
              submitCallback={({ result }) => {
                handleClose()
                enqueueSnackbar(<Trans>FEEDBACK_SUBMITTED_SNACKBAR</Trans>, {
                  variant: 'success'
                })
              }}
            >
              {({ saving, saveDisabled, submitDisabled }) => {
                return (
                  <Grid sx={{ pl: '12px', pr: '12px' }} container direction='row' gap='16px'>
                    {/* <Button
                      fullWidth
                      variant='contained'
                      disabled={submitDisabled as boolean || submitting}
                      color='primary'
                      onClick={() => submitData(values)}
                    >
                      <Trans>PROVIDE_FEEDBACK_SUBMIT_BUTTON</Trans>
                    </Button> */}
                    <Button
                      disabled={saving}
                      fullWidth
                      variant='outlined'
                      color='primary'
                      onClick={() => {
                        handleClose()
                      }}
                    >
                      <Trans>PROVIDE_FEEDBACK_CANCEL_BUTTON</Trans>
                    </Button>
                  </Grid>
                )
              }}
            </Form>
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}

export default ProvideFeedbackButton
